import React, { Component } from 'react';
import { Nav } from 'react-bootstrap';
import { FaPlusCircle, FaShoppingCart, FaClipboardList, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredItem: null,
    };
  }

  handleMouseEnter = (item) => {
    this.setState({ hoveredItem: item });
  };

  handleMouseLeave = () => {
    this.setState({ hoveredItem: null });
  };

  render() {
    const { setActiveComponent, setIsSidebarVisible } = this.props;
    const { hoveredItem } = this.state;

    const linkStyle = {
      display: 'flex',
      alignItems: 'center',
      padding: '10px 15px',
      color: '#fff',
      marginBottom: '15px',
      borderRadius: '8px',
      backgroundColor: '#495057',
      transition: 'background 0.3s ease',
      
    };

    const hoverStyle = {
      backgroundColor: '#6c757d',
      color: '#fff',
    };

    return (
      <div
        className="sidebar"
        style={{
          width: '250px',
          background: '#343a40',
          padding: '20px',
          height: '100vh',
          position: 'fixed',
          overflowY: 'auto',
          marginTop: '85px',
          color: '#fff',
          boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Nav className="flex-column">
          <Nav.Link
            href="#add-item"
            style={{
              ...linkStyle,
              ...(hoveredItem === 'add-item' ? hoverStyle : {}),
            }}
            onMouseEnter={() => this.handleMouseEnter('add-item')}
            onMouseLeave={this.handleMouseLeave}
            onClick={() => setActiveComponent('AddProduct')}
          >
            <FaPlusCircle style={{ marginRight: '10px' }} />
            Ajouter un Article
          </Nav.Link>

          <Nav.Link
            href="#my-sales"
            style={{
              ...linkStyle,
              ...(hoveredItem === 'my-sales' ? hoverStyle : {}),
            }}
            onMouseEnter={() => this.handleMouseEnter('my-sales')}
            onMouseLeave={this.handleMouseLeave}
            onClick={() => setActiveComponent('Product')}
          >
            <FaShoppingCart style={{ marginRight: '10px' }} />
            Mes Articles
          </Nav.Link>

          <Nav.Link
            href="#my-requests"
            style={{
              ...linkStyle,
              ...(hoveredItem === 'my-requests' ? hoverStyle : {}),
            }}
            onMouseEnter={() => this.handleMouseEnter('my-requests')}
            onMouseLeave={this.handleMouseLeave}
            onClick={() => setActiveComponent('Requests')}
          >
            <FaClipboardList style={{ marginRight: '10px' }} />
            Mes Demandes
          </Nav.Link>

          <Nav.Link
            href="#account"
            style={{
              ...linkStyle,
              ...(hoveredItem === 'account' ? hoverStyle : {}),
            }}
            onMouseEnter={() => this.handleMouseEnter('account')}
            onMouseLeave={this.handleMouseLeave}
            onClick={() => setActiveComponent('Profile')}
          >
            <FaUser style={{ marginRight: '10px' }} />
            Mon Compte
          </Nav.Link>

          <Nav.Link
            style={{
              ...linkStyle,
              ...(hoveredItem === 'Accueil' ? hoverStyle : {}),
            }}
            onMouseEnter={() => this.handleMouseEnter('Accueil')}
            onMouseLeave={this.handleMouseLeave}
            onClick={() => {
              setActiveComponent('Accueil');
              setIsSidebarVisible(false);
            }}
          >
         <Link to="/accueil" className="nav-link"  style={{
              ...linkStyle,
              ...(hoveredItem === 'Accueil' ? hoverStyle : {}),
            }}><FaClipboardList /> Quitter
            </Link>
                                 
            
          </Nav.Link>
        </Nav>
      </div>
    );
  }
}

export default Sidebar;
